<template>
  <span class="succession-help">
    <b-button :size="size" icon-left="help-circle-outline" @click="open = true">
      Ajutor
    </b-button>
    <b-sidebar
      :open.sync="open"
      type="is-white"
      fullheight
      overlay
      right
      class="succession-help-sidebar"
    >
      <div class="p-5">
        <div class="level is-mobile mb-4">
          <div class="level-left">
            <p class="title is-5">Ajutor - Succesiuni</p>
          </div>
          <div class="level-right">
            <button
              type="button"
              class="delete"
              aria-label="Inchide"
              @click="open = false"
            />
          </div>
        </div>
        <section
          v-for="section in sections"
          :key="section.title"
          class="content is-small mb-5"
        >
          <p class="heading has-text-weight-semibold">{{ section.title }}</p>
          <ol v-if="section.steps">
            <li v-for="(step, index) in section.steps" :key="index">
              {{ step }}
            </li>
          </ol>
          <template v-else>
            <div v-for="item in section.items" :key="item.key" class="mb-3">
              <p class="mb-1">
                <span v-if="item.tag" :class="['tag', item.tag]">{{
                  item.title
                }}</span>
                <strong v-else>{{ item.title }}</strong>
              </p>
              <p>{{ item.text }}</p>
            </div>
          </template>
        </section>
      </div>
    </b-sidebar>
  </span>
</template>

<script>
import {
  ACTION_HELP,
  CONCEPT_HELP,
  FLOW_HELP,
  STATUS_HELP,
} from "@/helpers/resdpsHelp";
import { ACTION_LABELS, STATUS_LABELS, statusTag } from "@/helpers/resdps";

const concepts = (keys) =>
  keys.map((key) => ({
    key,
    title: CONCEPT_HELP[key].title,
    text: CONCEPT_HELP[key].text,
  }));

// Panoul foloseste aceleasi texte ca tooltip-urile (helpers/resdpsHelp.js).
const SECTIONS = [
  { title: "Ce este un dosar", items: concepts(["file", "draft"]) },
  { title: "Drumul dosarului", steps: FLOW_HELP },
  {
    title: "Stari",
    items: Object.keys(STATUS_LABELS).map((status) => ({
      key: status,
      title: STATUS_LABELS[status],
      text: STATUS_HELP[status],
      tag: statusTag(status),
    })),
  },
  {
    title: "Butoane",
    items: Object.keys(ACTION_LABELS).map((action) => ({
      key: action,
      title: ACTION_LABELS[action],
      text: ACTION_HELP[action],
    })),
  },
  {
    title: "Termene si clasare",
    items: concepts(["transmissionDeadline", "classification"]),
  },
  { title: "Documente", items: concepts(["documents"]) },
  { title: "Registre", items: concepts(["register", "generalRegistry"]) },
  {
    title: "Formular, rectificari si istoric",
    items: concepts(["requiredMarks", "rectification", "history"]),
  },
];

export default {
  name: "SuccessionHelp",
  props: {
    // Implicit, dimensiunea butoanelor vecine; is-small in antetul unui card.
    size: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      open: false,
      sections: SECTIONS,
    };
  },
};
</script>

<style scoped>
.succession-help-sidebar ::v-deep .sidebar-content {
  width: 28rem;
  max-width: 100vw;
}
</style>
